import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { getIn, setIn } from 'formik';

import momentWithAustinTimezone from 'common/util/momentWithAustinTimezone';

import SrUserSettingDropdown from 'client/components/SrUserSettingDropdown';
import ButtonDeprecated, { BUTTON_THEME_BLUE } from 'client/components/ButtonDeprecated';

import UserActions from 'client/actions/User';

class SrUserSettingMonthsDropdown extends Component {
  static propTypes = {
    currentUser: PropTypes.object.isRequired,
    settingField: PropTypes.string.isRequired,
    dispatch: PropTypes.func.isRequired,
    startIndexMonth: PropTypes.number.isRequired,
    endIndexMonth: PropTypes.number.isRequired,
    placeholder: PropTypes.string,
  }

  static defaultProps = {
    placeholder: 'month',
  }

  constructor(props) {
    super(props);

    const settingValue = getIn(props.currentUser.settings, props.settingField);

    this.state = {
      settingValue: settingValue || [],
    };
  }

  _onUpdateSetting = (month) => {
    const { settingValue } = this.state;

    // User selects "all"
    if (month === undefined) {
      this.setState({ settingValue: undefined });
    }
    // User selects a different status and the current option is "all"
    else if (settingValue === undefined) {
      this.setState({ settingValue: [month] });
    }
    else {
      this.setState({
        settingValue: settingValue.includes(month)
          ? settingValue.filter((id) => id !== month)
          : [...settingValue, month],
      });
    }
  }

  _onSaveSettings = () => {
    const { currentUser, settingField, dispatch } = this.props;
    const { settingValue } = this.state;
    const newUserSettings = setIn({ ...currentUser.settings }, settingField, settingValue);
    dispatch(UserActions.updateSettings, newUserSettings);
  }

  render() {
    const {
      currentUser,
      settingField,
      dispatch,
      startIndexMonth,
      endIndexMonth,
      placeholder,
    } = this.props;

    if (typeof startIndexMonth !== 'number' || typeof endIndexMonth !== 'number') {
      return null;
    }

    const {
      settingValue,
    } = this.state;

    const options = [
      {
        label: 'all',
        value: undefined,
      },
    ];
    const optionsSelected = [];

    for (let monthIndex = startIndexMonth; monthIndex <= endIndexMonth; monthIndex += 1) {
      const date = momentWithAustinTimezone().set('date', 1).add(monthIndex, 'months');
      const label = date.format('MMMM YYYY').toLowerCase();
      const value = `${date.year()}_${date.month()}`;
      options.push({
        label,
        value,
      });
      if (settingValue && settingValue.includes(value)) {
        optionsSelected.push(label);
      }
    }
    const title = `${placeholder}: ${optionsSelected.length ? optionsSelected.join(', ') : 'all'}`;

    return (
      <SrUserSettingDropdown
        user={currentUser}
        settingField={settingField}
        settingValue={settingValue}
        title={title}
        options={options}
        onChange={this._onUpdateSetting}
        dispatch={dispatch}
        shouldUpdateSettings={false}
        multiple
        footer={(
          <div className='buttonContainer'>
            <ButtonDeprecated
              theme={BUTTON_THEME_BLUE}
              type='button'
              onClick={this._onSaveSettings}
            >
              save
            </ButtonDeprecated>
          </div>
        )}
      />
    );
  }
}

SrUserSettingMonthsDropdown.displayName = 'SrUserSettingMonthsDropdown';

export default SrUserSettingMonthsDropdown;
